
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/opportunities/[slug]",
      function () {
        return require("private-next-pages/opportunities/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/opportunities/[slug]"])
      });
    }
  